import React from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import * as actions from '../../../actions/homeData';
import List from '../../common/List';
import Form from '../../common/Form';
import { getSuggestions, getSearchUrl, redirect } from '../../../utils/common';
import { getStoreName, gtmEventPush, gtmEventPushPLP, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import luxescreen from '../../../refresh/constants/luxeScreenType';
import { getVariant, getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import { LUXE_STORE, STREET_STORE } from '../../../constants/constant';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import {
  getSearchFlags,
  getVertexEnabledAjiogram,
  getVertexEnabledLuxe,
  getChildStores
} from '../../../refresh/selectors/featureFlagsSelector';
import { getSearchExpFlags } from '../../../utils/products';
import { getPageInfoForGTM } from '../../../utils/pageInfo';
import { replaceWithJioCDN } from '../../../utils/imageHandling';
import {getAmplitudeVariantPayload , getAmplitudeVariantPayloadMap} from '../../../utils/amplitudeCommon';



export const  sanitize = (string) => {
  return String(string)
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&apos;')
  .replace(/%3C/g, '&lt;')
  .replace(/%3E/g, '&gt;')
  .replace(/%3c/g, '&lt;')
  .replace(/%3e/g, '&gt;')
}

class SearchBar extends React.Component {
  constructor() {
    super();
    this.state = {
      showResults: false,
      showSuggession: false,
      showTopSearches: false,
      cursor: null,
      inputval: '',
      suggestedUrl: '',
      allowClassifier: getVariant('set_search_classifier'),
      autoSuggestionTextVariant: getFeatureVariant('enable_auto_suggestion_text')
    };
  }

  validateSearchInput = (inputStr = '') => {
    if (typeof inputStr === 'string' && inputStr) {
      inputStr = inputStr.trim();
      const regex = /[a-z0-9]+/i;
      if (inputStr && regex.test(inputStr)) {
        return true;
      }
    }
    return false;
  };

  topSearchesListItemRenderer = ({ index }) => {
    const { topSearches = [], classifier, ABFlagObj, storeName } = this.props;
    const searchStore = ['ajio', 'luxe', 'ajiogram'].includes(storeName) ? storeName : 'ajio';
    const { cursor, allowClassifier } = this.state;
    const suggestion = topSearches[index];

    const searchAbFlagObj = JSON.stringify(ABFlagObj);

    let searhText = `/search/?text=${suggestion.value}${
      Object.keys(ABFlagObj)?.length > 0 ? `&searchAbFlagObj=${searchAbFlagObj}` : ''
    }`;
    if (allowClassifier) {
      searhText = `${searhText}&classifier=${classifier}`;
    }
    return (
      <a
        href={searhText}
        className={`search-suggestionList ${cursor === index ? ' active' : ''}`}
        onClick={() => {
          localStorage.setItem('search_plp_source_details', 'trending categories');
          localStorage.setItem('search_used', true)
          const { pageType, pageName } = getPageInfoForGTM(
            window.location.pathname,
            storeName === LUXE_STORE
          );
          let searchVal = document.getElementsByName('searchVal') || '';
          if (searchVal.length > 0) {
            searchVal = searchVal[0]?.value || '';
          }
          gtmEventPush({
            event: 'search_interactions',
            event_category: 'search interactions',
            event_action: 'top categories search',
            event_label: suggestion.value,
            search_term: suggestion.value,
            suggested_link: `/search/?text=${suggestion.url}`,
            page_name: `Search Screen/${searchStore}`,
            page_type: pageType
          });
          
        }}
      >
        <span>{suggestion.url}</span>
      </a>
    );
  };

  suggestionListItemRenderer = ({ index }) => {
    const {
      responseSource = '',
      suggestions = [],
      classifier,
      isStreetStore,
      storeName,
      ABFlagObj
    } = this.props;
    const { textsuggestions, storeSuggestions } = getSuggestions(suggestions);

    const searchStore = ['ajio', 'luxe', 'ajiogram'].includes(storeName) ? storeName : 'ajio';
    const { cursor, allowClassifier, autoSuggestionTextVariant } = this.state;

    const suggestion = textsuggestions[index];
    const item = suggestion.value;
    var suggestionUrl = `${suggestion.url}&query=${encodeURIComponent(item)}`;
    let { absolutePath = false, customClass = '', sis = false } = suggestion;
    const urlSplits = suggestionUrl.split(':');

    // NOTE: FOR VERTEX PHASE-2
    const isVertexSuggestion = (responseSource ?? '').toLowerCase() === 'vertex';
    const suggestionText = isVertexSuggestion ? `${item}` : suggestionUrl;

    var autoSuggestionUrl = `/search/?text=${suggestionText.trim()}`;
    // if (urlSplits[0] == "categoryID" || urlSplits[0] == "brands") {
    //   autoSuggestionUrl = `/search/?text=${suggestionUrl.trim()}`;
    // }
    if (absolutePath) {
      autoSuggestionUrl = suggestionUrl;
    }
    const searchAbFlagObj = JSON.stringify(ABFlagObj);
    autoSuggestionUrl = `${autoSuggestionUrl}${
      Object.keys(ABFlagObj)?.length > 0 ? `&searchAbFlagObj=${searchAbFlagObj}` : ''
    }`;
    const splitted = item.split(' in ');
    const lastWord = splitted.pop();
    let newTxt = '';
    if (splitted.length > 0) {
      newTxt = `${splitted.join(' ')} in `;
    } else {
      newTxt = splitted;
    }
    if (allowClassifier) {
      if (autoSuggestionUrl.indexOf('?') >= 0) {
        autoSuggestionUrl = `${autoSuggestionUrl}&classifier=${classifier}`;
      } else {
        autoSuggestionUrl = `${autoSuggestionUrl}?classifier=${classifier}`;
      }
    }
    if (autoSuggestionTextVariant === '1') {
      autoSuggestionUrl = `${autoSuggestionUrl}&searchedText=${encodeURIComponent(item)}`;
    }

    // NOTE: FOR VERTEX PHASE-2
    if (isVertexSuggestion) {
      autoSuggestionUrl = `${autoSuggestionUrl}&responseSource=vertex`;
    }

    return (
      <a
        href={autoSuggestionUrl}
        onClick={() => {
          localStorage.setItem('search_plp_source_details', 'auto suggestion search');
          localStorage.setItem('search_used', true)
          const { inputval } = this.state;
          const { pageType, pageName } = getPageInfoForGTM(
            window.location.pathname,
            storeName === LUXE_STORE
          );
          gtmEventPush({
            event: 'search_interactions',
            event_category: 'search interactions',
            event_action: 'auto search click',
            event_label: `${newTxt} ${lastWord}`.trim(),
            search_term: inputval,
            suggested_link: `/search/?text=${inputval}`,
            page_name: `Search Screen/${searchStore}`,
            page_type: pageType
          });
          // Segment Push Event
          segmentEventPush({
            event: 'Search Bar Interaction',
            event_category: 'search interactions',
            event_action: 'auto search click',
            event_label: `${newTxt} ${lastWord}`.trim(),
            search_term: inputval,
            raw_query: '',
            search_type: '',
            // suggested_link: `/search/?text=${inputval}`,
            screen_name: `Search Screen/${searchStore}`,
            // page_type: pageType
          });
        }}
        className={`search-suggestionList ${cursor === index ? ' active' : ''} ${customClass ||
          ''}`}
      >
        {sis && !isStreetStore && storeName !== STREET_STORE ? (
          <span className="ic-app-logo"> </span>
        ) : (
          ''
        )}
        <span>{newTxt}</span> <span className="higlighted-text">{lastWord}</span>
      </a>
    );
  };

  render() {
    const {
      suggestions = [],
      topSearches = [],
      metaData: {
        sis = false,
        name = 'Ajio',
        current: { colorTheme = '', textColor = '', headerIconColor = '', storeTitle = '' } = {}
      } = {},
      newDesignLuxe,
      classifier,
      isStreetStore,
      storeName,
      ABFlagObj,
      vertexEnabledAjiogram,
      vertexEnabledLuxe,
      vertexEnabled,
      vertexEnabledForSis,
      childStores
    } = this.props;
    const searchStore = ['ajio', 'luxe', 'ajiogram'].includes(storeName) ? storeName : 'ajio';
    const {
      showTopSearches = false,
      showSearchContainer = false,
      cursor,
      allowClassifier
    } = this.state;

    let styleObj =
      sis && !isStreetStore && storeName !== STREET_STORE ? { borderColor: colorTheme } : {};

    const { textsuggestions, storeSuggestions } = getSuggestions(suggestions);

    const normalizedStore = (storeName || '').toLowerCase();
    const childStoresLower = (childStores || []).map(s => s.toLowerCase());
    const isVertexSearchEnabled =
      (normalizedStore === 'ajiogram' && !!vertexEnabledAjiogram?.master) ||
      (normalizedStore === 'luxe' && !!vertexEnabledLuxe?.master) ||
      (['', 'ajio', 'rilfnl'].includes(normalizedStore) && vertexEnabled === 'ON') ||
      (childStoresLower.includes(normalizedStore) && !!vertexEnabledForSis);
    const searchText =
      sis && !isStreetStore && storeName !== STREET_STORE
        ? `Search in ${storeTitle[0].toUpperCase() + storeTitle.slice(1).toLowerCase()}`
        : 'Search AJIO';

    return (
      <Form
        role="search"
        onSubmit={formValues => {
          localStorage.setItem('search_plp_source_details', 'user completed search');
          localStorage.setItem('search_used', true)
          gtmEventPushPLP({
            'event': 'plp_navigation_interaction',
            'event_category': 'plp_interaction',
            'event_action': 'search click',
            'event_label': 'search',
            'store_type': 'ajio',
            'page_type': window.pageType || ''
          }, 'search click', true);
          let { searchVal = "" } = formValues;
          if (
            searchVal == '.' ||
            searchVal == '?' ||
            searchVal == '.?' ||
            searchVal == '?.' ||
            searchVal == '..?' ||
            searchVal == '..'
          ) {
            searchVal = '*';
          }
          if (searchVal !== '' && this.validateSearchInput(searchVal)) {
            const { pageType, pageName } = getPageInfoForGTM(
              window.location.pathname,
              storeName === LUXE_STORE
            );
            gtmEventPush({
              event: 'search_interactions',
              event_category: 'search interactions',
              event_action: 'custom search',
              event_label: searchVal,
              page_name: `Search Screen/${searchStore}`,
              page_type: pageType,
              search_term: searchVal
            });
            // Segment Push event
            segmentEventPush({
              event: 'Search Bar Interaction',
              event_category: 'search interactions',
              event_action: 'custom search',
              event_label: searchVal,
              screen_name: `Search Screen/${searchStore}`,
              // page_type: pageType,
              search_term: searchVal
            });
            const searchAbFlagObj = JSON.stringify(ABFlagObj);
            let path = `/search/?text=${escape(searchVal)}${
              Object.keys(ABFlagObj)?.length > 0 ? `&searchAbFlagObj=${searchAbFlagObj}` : ''
            }`;
            if (this.state.allowClassifier) {
              path = `${path}&classifier=${classifier}`;
            }
            if (path) {
              this.setState({
                suggestedUrl: path
              });
            }
            window.location = path;
          }
        }}
      >
        {({ getFormDefaultProps, addFormValue }) => {
          let showSearchContainerFlag = false;
          if (suggestions.length > 0 || (showTopSearches && topSearches.length > 0)) {
            showSearchContainerFlag = true;
          }
          return (
            <div className="searchbar-view" style={{ display: "flex" }}>
              <div className="react-autosuggest__container react-autosuggest__container--open">
                {sis && !isStreetStore && storeName !== STREET_STORE ? (
                  <p
                    className="sub-store-name"
                    style={{
                      backgroundColor: isStreetStore ? '' : colorTheme,
                      color: isStreetStore ? '' : headerIconColor
                    }}
                    aria-hidden={true}
                  >
                    {storeTitle?.toUpperCase()}
                  </p>
                ) : (
                  ''
                )}
                <input
                  autoComplete="off"
                  style={styleObj}
                  tabIndex={0}
                  // aria-label={searchText} //removed because giving double announcement, placeholder handles the case of label when data in inputfield
                  className="react-autosuggest__input react-autosuggest__input--open"
                  // style = {styleObj}
                  placeholder={searchText}
                  {...getFormDefaultProps({
                    type: 'text',
                    name: 'searchVal'
                  })}
                  onKeyDown={e => {
                    const { cursor, showTopSearches = false } = this.state;
                    const { suggestions = [], topSearches = [] } = this.props;
                    let currentSuggestions = suggestions;
                    if (showTopSearches) {
                      currentSuggestions = topSearches;
                    }
                    let nextCursor = cursor;
                    if (e.keyCode === 38 && cursor > 0) {
                      nextCursor = cursor != null && cursor !== 0 ? cursor - 1 : 0;
                    } else if (e.keyCode === 40 && cursor < currentSuggestions.length - 1) {
                      nextCursor = cursor != null ? cursor + 1 : 0;
                    } else if (
                      e.keyCode === 40 &&
                      cursor === null &&
                      nextCursor === null &&
                      suggestions.length === 1
                    ) {
                      nextCursor = 0;
                    }
                    if (suggestions[nextCursor]?.data_type == 'STORE') {
                      nextCursor = cursor;
                    }
                    if (e.keyCode === 38 || e.keyCode === 40) {
                      // check up and down key
                      const { name, value } = e.target;
                      addFormValue(name, suggestions[nextCursor].value);
                    }
                    this.setState({
                      cursor: nextCursor
                    });
                  }}
                  onChange={event => {
                    const { name, value } = event.target;
                    addFormValue(name, value);
                    this.props.fetchData(value, sis);
                    this.state.inputval = value;
                    this.setState({
                      showTopSearches: false,
                      showSearchContainer: true,
                      cursor: null
                    });
                    
                  }}
                  onFocus={e => {
                    // this.setState({
                    //   showSearchContainer: true
                    // });
                    // if (!e.target.value.length) {
                    //   this.setState({
                    //     showTopSearches: true
                    //   });
                    // }
                    const { pageType, pageName } = getPageInfoForGTM(
                      window.location.pathname,
                      storeName === LUXE_STORE
                    );
                    gtmEventPush({
                      event: 'search_bar_interactions',
                      event_category: 'search bar interactions',
                      event_action: 'search icon click',
                      event_label: '',
                      page_type: pageType
                    });
                    

                  }}
                  onClick={this.autoSuggestionDropDownClickHandler}
                />
                {showSearchContainer && showSearchContainerFlag ? (
                  <div
                    onClick={e => this.autoSuggestionDropDownClickHandler(e)}
                    id="react-autowhatever-1"
                    className="react-autosuggest__suggestions-container react-autosuggest__suggestions-container--open"
                  >
                    {textsuggestions.length > 0 ? (
                      <div id="react-autowhatever-1" className="">
                        <List
                          numOfItems={textsuggestions.length}
                          listItemRenderer={this.suggestionListItemRenderer}
                          search={this.state.inputval}
                          suggestedUrl={this.state.suggestedUrl}
                          ariaHidden={true}
                        />
                      </div>
                    ) : null}
                    {storeSuggestions.map(({ image_url, value, url }) => {
                      let redirectUri = getSearchUrl(url);
                      if (allowClassifier) {
                        const categoryArray = redirectUri.match(/shop\/([a-zA-Z]+)/) || [];
                        const category =
                          typeof categoryArray[1] !== 'undefined' ? categoryArray[1] : '';
                        if (
                          category === 'kurtas' ||
                          category === 'men' ||
                          category === 'adidas' ||
                          category === 'ajio' ||
                          category === 'luxe' ||
                          category === 'shirts'
                        ) {
                          redirectUri = redirectUri;
                        } else {
                          if (redirectUri.indexOf('?') >= 0) {
                            redirectUri = `${redirectUri}&classifier=${classifier}`;
                          } else {
                            redirectUri = `${redirectUri}?classifier=${classifier}`;
                          }
                        }
                        const searchAbFlagObj = JSON.stringify(ABFlagObj);
                        redirectUri = `${redirectUri}${
                          Object.keys(ABFlagObj)?.length > 0
                            ? `&searchAbFlagObj=${searchAbFlagObj}`
                            : ''
                        }`;
                      }
                      const funcToRedirect = () => {
                        let searchVal = document.getElementsByName('searchVal') || '';
                        if (searchVal.length > 0) {
                          searchVal = searchVal[0]?.value || '';
                        }
                        const { pageType, pageName } = getPageInfoForGTM(
                          window.location.pathname,
                          storeName === LUXE_STORE
                        );
                        gtmEventPush({
                          event: 'search_interactions',
                          event_category: 'search interactions',
                          event_action: 'auto search click - store',
                          event_label: value,
                          page_name: `Search Screen/${searchStore}`,
                          page_type: pageType,
                          search_term: searchVal
                        });

                        // Segment Push Event
                        segmentEventPush({
                          event: 'Search Bar Interaction',
                          event_category: 'search interactions',
                          event_action: 'auto search click - store',
                          event_label: value,
                          screen_name: `Search Screen/${searchStore}`,
                          // page_type: pageType,
                          search_term: searchVal,
                          raw_query: '',
                          search_type: ''

                        });
                        window.location.href = redirectUri;
                      };
                      return (
                        <div className="storeSuggestions_item" onClick={funcToRedirect}>
                          <img className="storeSuggestions_image" src={replaceWithJioCDN(image_url)} alt={value} />
                          <div className="storeSuggestions_text_container">
                            <div className="storeSuggestions_text">{value}</div>
                            <div className="storeSuggestions_subtext">Store</div>
                          </div>
                          <span className="ic-Forward storeSuggestions_icon" />
                        </div>
                      );
                    })}
                    {showTopSearches && topSearches.length > 0 ? (
                      <div className="autosuggesssion-top-searches" id="react-autowhatever-1">
                        <div className="top-searches-title" aria-label="Top Searches">Top Searches</div>
                        <List
                          numOfItems={topSearches.length}
                          listItemRenderer={this.topSearchesListItemRenderer}
                          ariaHidden={true}
                        />
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
              <button
                type="submit"
                className="rilrtl-button"
                style={{ backgroundColor: isStreetStore ? '' : colorTheme }}
                aria-label='Submit search'
              >
                <span
                  className="ic-search"
                  onClick={this.handleSubmit}
                  style={{ color: isStreetStore ? '' : headerIconColor }}
                />
              </button>
            </div>
          );
        }}
      </Form>
    );
  }

  hideAutoSuggestDropDown = () => {
    this.setState({
      showSearchContainer: false,
      showTopSearches: false,
      cursor: null
    });
  };

  componentDidMount() {
    this.props.fetchTopSearches();
    document.addEventListener('click', this.hideAutoSuggestDropDown);
    window.addEventListener('scroll', this.hideAutoSuggestDropDown);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.hideAutoSuggestDropDown);
    window.removeEventListener('scroll', this.hideAutoSuggestDropDown);
  }

  autoSuggestionDropDownClickHandler(e) {
    e.nativeEvent.stopImmediatePropagation();
  }
}

const mapStateToProps = state => {
  const { search = {}, metaData = {}, flags = {} } = state;
  const { suggestions = [], topSearches = [], responseSource = '' } = search;
  const storeName = getCurrentStore(state);

  const searchFlags = getAmplitudeVariantPayload('searchExpFlags',state, getSearchFlags(state));
  

  let ABFlagObj = (state?.flags?.amplitude_experiment_flag == 'ON') ? getAmplitudeVariantPayloadMap(searchFlags, state) : getSearchExpFlags(searchFlags);

  const vertexEnabledAjiogram = getVertexEnabledAjiogram(state);
  const vertexEnabledLuxe = getVertexEnabledLuxe(state);
  const vertexEnabled = flags?.vertexEnabled;
  const vertexEnabledForSis = !!flags?.vertexEnabledForSis;
  const childStores = getChildStores(state) || [];

  return {
    responseSource,
    suggestions,
    topSearches,
    metaData,
    classifier: flags?.classifier || 'nb',
    storeName,
    ABFlagObj: ABFlagObj || {},
    vertexEnabledAjiogram,
    vertexEnabledLuxe,
    vertexEnabled,
    vertexEnabledForSis,
    childStores
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: debounce((value, sis) => {
      segmentEventPush({
        event: 'Search Bar Interaction',
        event_category: 'search bar interactions',
        //event_action: 'search icon click',
        //event_label: '',
        //page_type: pageType,
        search_term: value,
        search_type:'',
        raw_query: ''

      });

      dispatch(actions.getSearchDetails(value, sis));
      
    }, 700),
    fetchTopSearches: () => dispatch(actions.fetchTopSearches())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);
